import React, { useState } from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import moment from "moment";

function ReferralEntity({ referrals, ...rest }) {
  const openReferral = (referrals) => {};
  return (
    <>
      <div className="h5 border-bottom">Referrals</div>
      {referrals && referrals.length > 0 ? (
        referrals.map((referral) => (
          <Card key={referral.ReferralId} className="card-safy">
            <Card.Header className="p-0 ps-2 bg-safy1-1 text-white">
              <div className="row">
                <div className="col-10 ps-4 pt-1">
                  {moment.utc(referral.DateofReferral).format("MM/DD/YY")}
                </div>
                <div className="col-2">
                  <Link
                    title="Referral Record"
                    to={`/referral/${referral.ReferralId}`}
                  >
                    <i className="fas fa-pen float-end p-2 text-white"></i>
                  </Link>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="p-2 card-body-safy">
              <FieldDisplay
                label="Program:"
                value={referral.ProposedProgramName}
              />
              {referral.ReferringAgencyName !== undefined && (
                <FieldDisplay
                  label="Referring Agency:"
                  value={referral.ReferringAgencyName}
                />
              )}
              {referral.DynamicFields &&
                referral.DynamicFields.results &&
                referral.DynamicFields.results.referringWorker && (
                  <FieldDisplay
                    label="Referring Worker:"
                    value={referral.DynamicFields.results.referringWorker.text}
                  />
                )}
              <FieldDisplay label="Status:" value={referral.Status} />
            </Card.Body>
          </Card>
        ))
      ) : (
        <div>No Referrals</div>
      )}
    </>
  );
}

export default ReferralEntity;
